/* acaciasupplies — index.js
   El Shop (/collections/index y las colecciones de categoría): filtros,
   «What do you carry?», la vista de tabla («Compare specs») y su orden.
   Sin dependencias. Si no hay rejilla, no hace nada.

   Store-v9-1 S3 (12 oct 2026): dos vistas y no tres (la lista impuesta por
   falta de fotos ya no existe: en el Shop no hay productos sin foto), un
   botón y no un conmutador, la fila de filtros Type · Maker · Laptop ·
   Made in en <select>, y fuera el comparador de casillas: «Compare specs»
   ES la comparación, con todos los productos en la misma tabla.

   Tarjetas <li> y filas <tr> llevan los mismos `data-*`, así que el filtro
   es uno solo y no sabe qué vista está activa. */
(function () {
  'use strict';

  var VIEW_KEY = 'as-index-view';
  var SORT_KEY = 'as-index-sort';

  /* NO USAR `?view=`: Shopify lo reserva para el sufijo de plantilla
     (`?view=table` pediría `collection.table.json`, que no existe, y la
     página saldría en 200 con otra sección). Ver docs/index-table.md §1. */
  var VIEW_PARAM = 'index-view';

  var grid = document.querySelector('[data-index-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-index-card]'));
  if (!cards.length) return;
  var total = cards.length;

  var viewsBox = document.querySelector('[data-index-views]');
  var toggle = document.querySelector('[data-view-toggle]');
  var dataTable = document.querySelector('[data-index-table]');
  var tableBody = document.querySelector('[data-index-tbody]');
  /* Antes de ordenar nada: el orden del servidor, al que se vuelve cuando no
     hay columna ordenada. */
  var tableRows = tableBody
    ? Array.prototype.slice.call(tableBody.querySelectorAll('[data-index-row]'))
    : [];

  var filtersBox = document.querySelector('[data-index-filters]');
  var countBox = document.querySelector('[data-index-count]');
  var noneBox = document.querySelector('[data-index-none]');
  var fitsBox = document.querySelector('[data-index-fits]');
  var fitsResult = document.querySelector('[data-fits-result]');
  var fitsNone = document.querySelector('[data-fits-none]');

  function plural(n) {
    return n === 1 ? ' product' : ' products';
  }

  /* ── Estado ───────────────────────────────────────────────────────────── */
  var state = {
    type: '',
    maker: '',
    made: '',
    laptopRow: 0,
    laptop: 0,
    extras: []
  };

  function listOf(value) {
    return String(value || '').split(' ').filter(Boolean);
  }

  function laptopOf(node) {
    return parseInt(node.getAttribute('data-laptop'), 10) || 0;
  }

  function matches(node) {
    if (state.type && node.getAttribute('data-type') !== state.type) return false;
    if (state.maker && node.getAttribute('data-maker') !== state.maker) return false;
    if (state.made && node.getAttribute('data-made') !== state.made) return false;
    if (state.laptopRow > 0 && laptopOf(node) < state.laptopRow) return false;
    if (state.laptop > 0 && laptopOf(node) < state.laptop) return false;
    if (state.extras.length) {
      var has = listOf(node.getAttribute('data-extras'));
      for (var i = 0; i < state.extras.length; i++) {
        if (has.indexOf(state.extras[i]) === -1) return false;
      }
    }
    return true;
  }

  function isFitsActive() {
    return state.laptop > 0 || state.extras.length > 0;
  }

  function isAnyActive() {
    return isFitsActive() || !!(state.type || state.maker || state.made || state.laptopRow);
  }

  function apply() {
    var shown = 0;
    cards.forEach(function (card) {
      var ok = matches(card);
      card.hidden = !ok;
      if (ok) shown++;
    });
    tableRows.forEach(function (row) {
      row.hidden = !matches(row);
    });

    if (countBox) {
      countBox.textContent = isAnyActive()
        ? shown + ' of ' + total + plural(total)
        : total + plural(total);
    }
    if (fitsResult) {
      fitsResult.textContent = isFitsActive() ? shown + ' of ' + total + plural(total) + ' fit.' : '';
    }
    var empty = shown === 0;
    if (noneBox) noneBox.hidden = !(empty && !isFitsActive());
    if (fitsNone) fitsNone.hidden = !(empty && isFitsActive());
  }

  /* ── Vista: rejilla o tabla ────────────────────────────────────────────
     El guion en línea de `index-grid` ya ha aplicado la vista pedida antes
     del primer pintado. Aquí se repite la cuenta (mismo resultado, sin
     salto) y se cablea el botón. Orden: `?index-view=` sobre la pestaña,
     la pestaña sobre la rejilla. */
  function readUrlView() {
    try {
      var asked = new URLSearchParams(window.location.search).get(VIEW_PARAM);
      return asked === 'grid' || asked === 'table' ? asked : null;
    } catch (error) {
      return null;
    }
  }

  function readView() {
    try {
      var saved = window.sessionStorage.getItem(VIEW_KEY);
      return saved === 'grid' || saved === 'table' ? saved : null;
    } catch (error) {
      return null;
    }
  }

  function writeView(view) {
    try {
      window.sessionStorage.setItem(VIEW_KEY, view);
    } catch (error) {
      /* Modo privado o almacenamiento lleno: la vista vale para esta página
         y no se recuerda. No es motivo para romper nada. */
    }
  }

  var currentView = 'grid';

  function applyView(view, remember) {
    currentView = view === 'table' ? 'table' : 'grid';
    if (viewsBox) viewsBox.className = 'index-views index-views--' + currentView;
    if (toggle) {
      toggle.textContent = toggle.getAttribute(currentView === 'table' ? 'data-table-label' : 'data-grid-label');
      toggle.setAttribute('aria-pressed', currentView === 'table' ? 'true' : 'false');
    }
    if (remember) writeView(currentView);
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      applyView(currentView === 'table' ? 'grid' : 'table', true);
    });
  }

  var askedView = readUrlView();
  applyView(askedView || readView() || 'grid', askedView !== null);

  /* ── Fila de filtros ──────────────────────────────────────────────────── */
  if (filtersBox) {
    filtersBox.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.getAttribute) return;
      var key = input.getAttribute('data-filter');
      if (!key) return;
      if (key === 'laptop') state.laptopRow = parseInt(input.value, 10) || 0;
      else state[key] = input.value;
      apply();
    });
  }

  /* ── What do you carry? ───────────────────────────────────────────────── */
  if (fitsBox) {
    var laptopSelect = fitsBox.querySelector('[data-fits-laptop]');
    var extraBoxes = Array.prototype.slice.call(fitsBox.querySelectorAll('[data-fits-extra]'));
    var resetButton = fitsBox.querySelector('[data-fits-reset]');

    var readFits = function () {
      state.laptop = laptopSelect ? parseInt(laptopSelect.value, 10) || 0 : 0;
      state.extras = extraBoxes.filter(function (box) {
        return box.checked;
      }).map(function (box) {
        return box.value;
      });
      apply();
    };

    fitsBox.addEventListener('change', readFits);
    fitsBox.addEventListener('submit', function (event) {
      event.preventDefault();
      readFits();
    });

    /* Relevo del prefiltro de la URL: `index-grid` escondió las tarjetas
       con una hoja en línea antes de pintarlas y `index-fits` marcó los
       controles. Aquí se marca el MISMO conjunto con `hidden` y solo
       entonces se retira la hoja: el resultado no cambia, no hay salto. */
    var prefill = window.acaciasupplies && window.acaciasupplies.indexPrefill;
    if (prefill) {
      readFits();
      var prefilter = document.getElementById('index-prefilter');
      if (prefilter && prefilter.parentNode) prefilter.parentNode.removeChild(prefilter);
    }

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (laptopSelect) laptopSelect.value = '0';
        extraBoxes.forEach(function (box) {
          box.checked = false;
        });
        readFits();
      });
    }
  }

  /* ── Orden de la tabla ─────────────────────────────────────────────────
     Sobre `#index-data`, no sobre el texto de las celdas: un número se
     compara como número y un hueco se reconoce como hueco. Lo que no tiene
     dato va SIEMPRE al final. Sin columna elegida, el orden del servidor. */
  var byCode = {};
  var dataNode = document.getElementById('index-data');
  if (dataNode) {
    try {
      (JSON.parse(dataNode.textContent) || []).forEach(function (row) {
        byCode[row.code] = row;
      });
    } catch (error) {
      /* Sin blob legible la tabla se queda en el orden del servidor, que
         sigue siendo correcto; se dice en la consola para poder verlo. */
      if (window.console) window.console.warn('index-data: ' + error.message);
    }
  }

  var SORT_STRINGS = { name: 'name', type: 'type', maker: 'maker', made: 'country' };
  var SORT_NUMBERS = { weight: 'weight', capacity: 'capacity' };

  function numberOf(value) {
    if (value === '' || value === null || typeof value === 'undefined') return null;
    var parsed = parseFloat(String(value).replace(',', '.'));
    return isNaN(parsed) ? null : parsed;
  }

  function sortValue(code, key) {
    var row = byCode[code];
    if (!row) return null;
    if (SORT_STRINGS[key]) {
      var text = row[SORT_STRINGS[key]];
      return text ? String(text).toUpperCase() : null;
    }
    if (SORT_NUMBERS[key]) return numberOf(row[SORT_NUMBERS[key]]);
    if (key === 'w') return row.w > 0 ? row.w : null;
    if (key === 'laptop') return row.laptop > 0 ? row.laptop : null;
    /* Las tres casillas. Sin `fits_extras` no hay dato: no es un «no». */
    if (!row.hasExtras) return null;
    return listOf(row.extras).indexOf(key) === -1 ? 0 : 1;
  }

  function compareRows(a, b, key, dir) {
    var va = sortValue(a.getAttribute('data-code'), key);
    var vb = sortValue(b.getAttribute('data-code'), key);
    if (va === null && vb === null) return 0;
    if (va === null) return 1;
    if (vb === null) return -1;
    var out = typeof va === 'string' ? (va < vb ? -1 : (va > vb ? 1 : 0)) : va - vb;
    return dir === 'descending' ? -out : out;
  }

  var sortState = { key: '', dir: 'ascending' };

  function readSort() {
    try {
      var raw = window.sessionStorage.getItem(SORT_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.key) return null;
      return { key: parsed.key, dir: parsed.dir === 'descending' ? 'descending' : 'ascending' };
    } catch (error) {
      return null;
    }
  }

  function writeSort() {
    try {
      window.sessionStorage.setItem(SORT_KEY, JSON.stringify(sortState));
    } catch (error) {
      /* El orden vale para esta página y no se recuerda. */
    }
  }

  function applySort(remember) {
    if (!dataTable || !tableBody) return;
    Array.prototype.forEach.call(dataTable.querySelectorAll('[data-sort-col]'), function (head) {
      var mine = head.getAttribute('data-sort-col') === sortState.key;
      head.setAttribute('aria-sort', mine ? sortState.dir : 'none');
    });
    var order = tableRows.slice();
    if (sortState.key) {
      order.sort(function (a, b) {
        return compareRows(a, b, sortState.key, sortState.dir);
      });
    }
    order.forEach(function (row) {
      tableBody.appendChild(row);
    });
    if (remember) writeSort();
  }

  if (dataTable) {
    dataTable.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-sort]') : null;
      if (!button) return;
      var key = button.getAttribute('data-sort');
      sortState = {
        key: key,
        dir: sortState.key === key && sortState.dir === 'ascending' ? 'descending' : 'ascending'
      };
      applySort(true);
    });
    var savedSort = readSort();
    if (savedSort) {
      sortState = savedSort;
      applySort(false);
    }
  }

  apply();
})();
